/**
 * Peer -- unified contact model normalizing LLM bots and worker roles
 * into a single shape: { roleId, type, displayName, mentionName, description, roleType, online, ... }
 */

function toMentionName(displayName: string | undefined) {
  return (displayName || 'Bot')
    .replace(/[^a-zA-Z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
}

export function createPeerFromBot(bot: any) {
  return {
    roleId: bot.botId,
    type: 'llm-bot' as const,
    displayName: bot.displayName,
    mentionName: toMentionName(bot.displayName),
    description: bot.description,
    roleType: 'host' as const,
    online: true,
    botConfig: bot,
  }
}

export function createPeerFromWorker(role: any) {
  return {
    roleId: role.roleId,
    type: 'worker' as const,
    displayName: role.displayName,
    mentionName: toMentionName(role.displayName),
    description: role.description,
    roleType: role.roleType,
    typeName: role.typeName,
    online: role.online ?? false,
    workerPublicKey: role.roleId,
  }
}

export function canHost(peer: any) {
  return peer.type === 'llm-bot' || peer.roleType === 'chat'
}

/**
 * Merge LLM bots and worker roles into a single Peer list.
 */
export function mergePeers(llmBots: any[], workerRoles: any[], excludeIds?: string[]) {
  const exclude = excludeIds ? new Set(excludeIds) : null
  const botPeers = (llmBots || [])
    .filter((b: any) => !exclude || !exclude.has(b.botId))
    .map(createPeerFromBot)
  const workerPeers = (workerRoles || []).map(createPeerFromWorker)
  return [...botPeers, ...workerPeers]
}
